import { Card as MuiCard } from '@material-ui/core'
import styled from 'styled-components'

export const Card = styled(MuiCard)`
  padding: 24px;
  border-radius: 8px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.coolGray.cool100};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool200};
  min-width: fit-content;
  flex: 1 1;
  cursor: pointer;
`

export const CardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
export const CardLabel = styled.label`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.global.headers};
  cursor: pointer;
`

export const SalesOverview = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.blackPearlBlue.shade700};
  font-family: ${({ theme }) => theme.fonts.global.headers};
  margin-bottom: 0;
`

export const CardIcon = styled.div`
  width: 16px;
  color: ${({ theme }) => theme.colors.text.primary};
`
